/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { getType } from './type';

export function isString(val: any): val is string {
  return typeof val === 'string';
}
export function isFunction(val: any): val is Function {
  const type = getType(val);
  return type === 'Function' || type === 'AsyncFunction';
}

export function isNull(val: any): val is null {
  return getType(val) === 'Null';
}

export function isArray<T = any>(val: any): val is T[] {
  return Array.isArray ? Array.isArray(val) : getType(val) === 'Array';
}

export function isObject(val: any): val is object {
  return !isNull(val) && (isFunction(val) || typeof val === 'object');
}

export function isNumber(val: any): val is number {
  return typeof val === 'number';
}
